import React, { Fragment, useState, useEffect } from 'react'
import { Box, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import Colors from '../../Assets/Styles/Colors';
import BreadCrumbs from '../../Components/BreadCrumbs/BreadCrumbs';
import { CircleLoading } from '../../Components/Loaders/CircleLoading';
import { useNavigate } from 'react-router-dom';
import EventServices from '../../Api/Events/EventServices';
import { PrimaryButton } from '../../Components/Buttons';
import * as XLSX from "xlsx";
import { saveAs } from 'file-saver';

const tableHead = [
  "Name",
  "Email",
  "Phone",
  "Company",
  "Event",
  "No. of Tables",
  "No. of Seats",
  "No. of Passes",
  "Category",
  "Price",
];

function TablePaginationActions(props) {
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        <KeyboardArrowRight />
      </IconButton>
    </Box>
  );
}

function Events() {
  const [events, setEvents] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const getEvents = async (page, limit) => {
    setLoading(true);
    try {
      const result = await EventServices.getEvents(page ? page : 1, limit ? limit : 10);
      if (result.responseCode == 200) {
        setEvents(result?.data?.userEvents);
        setCount(result.data.totalEvents);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = () => {
    const eventValues = events.map(event => [
      event.name || "-",
      event.email || "-",
      event.phoneNumber || "-",
      event.companyName || "-",
      event?.event?.eventName || "-",
      event.totalTables || "-",
      event.totalSeats || "-",
      event.passes || "-",
      event.category || "-",
      event.price || "-"
    ]);

    const ws = XLSX.utils.aoa_to_sheet([tableHead, ...eventValues]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Convert the workbook to an array buffer
    const buf = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
      mimeType:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Save the file using FileSaver.js
    saveAs(new Blob([buf]), "dragons.xlsx");
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getEvents(newPage + 1, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(Math.floor(event.target.value));
    setPage(0);
    getEvents(page, event.target.value);
  };

  useEffect(() => {
    getEvents();
  }, []);

  return (
    <Fragment>
      <Box
        sx={{
          borderRadius: "12px",
          display: "flex",
          flexDirection: "column",
          gap: 2
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{
            background: Colors.primaryGradient,
            p: 2,
            borderRadius: "12px",
          }}
        >
          <Grid item xs={6}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <IconButton onClick={() => navigate(-1)}>
                <KeyboardArrowLeft sx={{ color: Colors.white }} />
              </IconButton>
              <Typography variant="body1" fontWeight="bold" sx={{ color: Colors.white }}>
                Events
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage={["Events"]} />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <PrimaryButton
                title={"Download Excel"}
                onClick={() => handleDownload()}
              />
            </Box>
          </Grid>
        </Grid>
        <Box>
          {loading ? (
            <CircleLoading />
          ) : (
            <Fragment>
              <TableContainer
                component={Paper}
                sx={{
                  // width: "calc(100vw - 320px)",
                  "&::-webkit-scrollbar": {
                    bgcolor: Colors.white,
                    height: "8px",
                    borderRadius: "10px",
                    cursor: "pointer",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    bgcolor: Colors.primary,
                    borderRadius: "10px",
                    cursor: "pointer",
                  },
                  "&.MuiPaper-root": {
                    borderRadius: "12px",
                    boxShadow: 0,
                  },
                }}
              >
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow sx={{ bgcolor: Colors.lightGray }}>
                      {tableHead.map((item, index) => (
                        <TableCell key={index}>
                          <Typography
                            sx={{
                              fontWeight: "bold",
                              // textAlign: item == "Posted By" ? "center" : item == "Actions" && "end",
                              width: "130px",
                            }}
                          >
                            {item}
                          </Typography>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {events.map((item) => (
                      <TableRow key={item?._id}>
                        <TableCell>{item?.name || "-"}</TableCell>
                        <TableCell>{item?.email || "-"}</TableCell>
                        <TableCell>{item?.phoneNumber || "-"}</TableCell>
                        <TableCell>{item?.companyName || "-"}</TableCell>
                        <TableCell>{item?.event?.eventName || "-"}</TableCell>
                        <TableCell>{item?.totalTables || "-"}</TableCell>
                        <TableCell>{item?.totalSeats || "-"}</TableCell>
                        <TableCell>{item?.passes || "-"}</TableCell>
                        <TableCell>{item?.category || "-"}</TableCell>
                        <TableCell>{item?.price || "-"}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Table sx={{ marginTop: "12px" }}>
                <TablePagination
                  sx={{
                    borderBottom: "none",
                    bgcolor: Colors.white,
                    borderRadius: "12px",
                  }}
                  rowsPerPageOptions={[10, 20, 30]}
                  colSpan={12}
                  count={+count}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: {
                      "aria-label": "rows per page",
                    },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </Table>
            </Fragment>
          )}
        </Box>
      </Box>
    </Fragment>
  )
}

export default Events